import { api, type Api } from "@api/bot-base-api-request";
import { useMutation } from "@tanstack/react-query";
import {
  NotificationParams,
  useNotification,
} from "@providers/notifications-bot-actions/notifications-bot-actions.tsx";

const BOT_LIMIT_BUY_QUERY_KEY = "bot-limit-buy";

type BotLimitBuyParams = {
  appPubKey: string;
  userId: string;
  chainId: number;
  tokenAddress: string;
  walletAddress: string;
  amount: string;
  slippage?: number;
  triggerPrice: string | number;
  isAutoSellOn: boolean;
};

type BotLimitBuyInput = {
  params: BotLimitBuyParams;
  notifyParams: NotificationParams;
};

const postBotLimitBuy = async (api: Api, params: BotLimitBuyParams) =>
  api.post("orders/limitBuy", { json: params }).json();

const useBotLimitBuyMutation = () => {
  const { setNotifyProps } = useNotification();

  return useMutation<unknown, Error, BotLimitBuyInput>({
    mutationFn: async (input: BotLimitBuyInput) =>
      postBotLimitBuy(api, input.params),
    mutationKey: [BOT_LIMIT_BUY_QUERY_KEY],
    onSuccess: async (_data, variables) => {
      setNotifyProps({
        type: "success",
        action: "placeLimitBuy",
        params: {
          youReceive: variables.notifyParams.youReceive,
          tokenSymbol: variables.notifyParams.tokenSymbol,
          youPayNative: variables.notifyParams.youPayNative,
          chainSymbol: variables.notifyParams.chainSymbol,
          limitPrice: variables.params.triggerPrice,
        } as NotificationParams,
      });
    },
    onError: async (_error, variables) => {
      setNotifyProps({
        type: "error",
        action: "placeLimitBuy",
        params: {
          youReceive: variables.notifyParams.youReceive,
          tokenSymbol: variables.notifyParams.tokenSymbol,
          youPayNative: variables.notifyParams.youPayNative,
          chainSymbol: variables.notifyParams.chainSymbol,
          limitPrice: variables.params.triggerPrice,
        } as NotificationParams,
      });
    },
  });
};

export { useBotLimitBuyMutation, postBotLimitBuy, BOT_LIMIT_BUY_QUERY_KEY };
